module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/callouts/callouts.component.html
// module id = ./src/app/callouts/callouts.component.html
// module chunks = main